//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uniIcons from "@/components/uni-icon/uni-icon.vue"
export default {
  data() {
    return {
      setMealShow: false,
      setMealShowUp: false,
      count: 5,
      score: 5
    };
  },
  components: { uniIcons },
  props: {
    isVoucher: {
      type: Boolean
    },
    list: {
      type: Array,
      default() {
        return []
      }
    }
  }
}
